import { TFunction } from 'i18next';
import TaskDTO from 'models/dto/tasks/taskDTO';
import ReportRequestDTO from './ReportRequestDTO';

export class ReportRequest3DTO extends ReportRequestDTO {
  taskColumns: string[];

  chartSeriesLabels: string[];

  chartYAxisLabel: string;

  unAssignedUserName: string;

  series: TaskDTO[];

  tasks: TaskDTO[];

  constructor(report: ReportRequestDTO, t?: TFunction<string[]>) {
    super(report);
    this.series = [];
    this.tasks = [];
    this.taskColumns = [];
    this.chartSeriesLabels = [];
    this.chartYAxisLabel = '';
    this.unAssignedUserName = '';

    if (t) {
      this.taskColumns = [
        t('translation:General.EntityType.Task'),
        t('task:Description.Label'),
        t('reports:Columns.Assignee'),
        t('tags:General.Name'),
        t('task:Repeat.Title'),
        t('dateTimeComponent:MonthsShort.Jan'),
        t('dateTimeComponent:MonthsShort.Feb'),
        t('dateTimeComponent:MonthsShort.Mar'),
        t('dateTimeComponent:MonthsShort.Apr'),
        t('dateTimeComponent:MonthsShort.May'),
        t('dateTimeComponent:MonthsShort.Jun'),
        t('dateTimeComponent:MonthsShort.Jul'),
        t('dateTimeComponent:MonthsShort.Aug'),
        t('dateTimeComponent:MonthsShort.Sep'),
        t('dateTimeComponent:MonthsShort.Oct'),
        t('dateTimeComponent:MonthsShort.Nov'),
        t('dateTimeComponent:MonthsShort.Dec'),
      ];

      this.chartSeriesLabels = [
        t('tasks:Reports.TaskStatusCompleted'),
        t('tasks:Reports.TaskStatusNotCompleted'),
        t('tasks:Reports.TaskStatusOverDeadline'),
      ];

      this.chartYAxisLabel = t('tasks:Reports.TaskCount');
      this.unAssignedUserName = t('tasks:Reports.UnAssignedUserName');
    }
  }

  clone(): ReportRequest3DTO {
    const output = new ReportRequest3DTO(this);
    output.series = [...this.series];
    output.tasks = [...this.tasks];
    output.taskColumns = [...this.taskColumns];
    output.chartSeriesLabels = [...this.chartSeriesLabels];
    output.chartYAxisLabel = this.chartYAxisLabel;

    return output;
  }
}
